import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Register from '@/views/Register.vue'
import Login from '@/views/auth/Login.vue'
import Callback from '@/views/auth/Callback.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import CreateNewPassword from '@/views/CreateNewPassword.vue'
import NotFound from '@/views/NotFound.vue'
import Admin from './Admin'
import Learn from './Learn'
import UserProfile from './UserProfile'
import CustomerSupport from './CustomerSupport'
import { logout } from '@/helpers/authHelper'
import { addMiddlewares } from './guards'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: () => {
      logout()
    }
  },
  {
    path: '/forgotPassword',
    name: 'Forgot Password',
    component: ForgotPassword
  },
  {
    path: '/createNewPassword/:changePasswordId',
    name: 'Create New Password',
    component: CreateNewPassword
  },
  {
    path: '*',
    name: 'Not Found',
    component: NotFound
  },
  Admin,
  Learn,
  UserProfile,
  CustomerSupport,
]

const router = new VueRouter({
  mode: 'history',
  routes
})

addMiddlewares(router)

export default router
